export interface SpecialClaimInfo {
    id: string,
    dataType: string,
    userInputType?: string,
    displayName?: string
}

export default {
    customPolicySchema: {
        protocols: {
            AAD: {
                name: 'Proprietary',
                handler:
                    'Web.TPEngine.Providers.AzureActiveDirectoryProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
            },
            selfAsserted: {
                name: 'Proprietary',
                handler:
                    'Web.TPEngine.Providers.SelfAssertedAttributeProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
            },
            appInsights: {
                name: 'Proprietary',
                handler:
                    'Web.TPEngine.Providers.Insights.AzureApplicationInsightsProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
            },
            claimsTransformation: {
                name: 'Proprietary',
                handler:
                    'Web.TPEngine.Providers.ClaimsTransformationProtocolProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
            },
            OAuth2: {
                name: 'OAuth2',
            },
            openIdConnect: {
                name: 'OpenIdConnect',
            },
            saml2: {
                name: 'SAML2',
            },
            noopSSO: {
                name: 'Proprietary',
                handler:
                    'Web.TPEngine.SSO.NoopSSOSessionProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
            },
            externalLoginSSO: {
                name: 'Proprietary',
                handler:
                    'Web.TPEngine.SSO.ExternalLoginSSOSessionProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
            },
            defaultSSO: {
                name: 'Proprietary',
                handler:
                    'Web.TPEngine.SSO.DefaultSSOSessionProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
            },
            oAuthSSO: {
                name: 'Proprietary',
                handler:
                    'Web.TPEngine.SSO.OAuthSSOSessionProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
            },
            samlSSO: {
                name: 'Proprietary',
                handler:
                    'Web.TPEngine.SSO.SamlSSOSessionProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
            },
            aadSspr: {
                name: 'Proprietary',
                handler:
                    'Web.TPEngine.Providers.AadSsprProtocolProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
            },
            REST: {
                name: 'Proprietary',
                handler:
                    'Web.TPEngine.Providers.RestfulProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
            },
            phoneFactor: {
                name: 'Proprietary',
                handler:
                    'Web.TPEngine.Providers.PhoneFactorProtocolProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
            },
            conditionalAccess: {
                name: 'Proprietary',
                handler:
                    'Web.TPEngine.Providers.ConditionalAccessProtocolProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
            },
            none: {
                name: 'None',
            },
            oneTimePassword: {
                name: 'Proprietary',
                handler:
                    'Web.TPEngine.Providers.OneTimePasswordProtocolProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
            },
            azureMfa: {
                name: 'Proprietary',
                handler: "Web.TPEngine.Providers.AzureMfaProtocolProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null"
            },
        },
        tokenIssuerTypes: {
            oidc: {
                type: 'oidc',
                protocol: 'openIdConnect',
                tokenFormat: 'JWT',
            },
            saml: {
                type: 'saml',
                protocol: 'saml2',
                tokenFormat: 'SAML2',
            },
        },
        userInfoEndpoint: {
            clientAssertionType: 'urn:ietf:params:oauth:client-assertion-type:jwt-bearer',
        },
        xmlStrings: {
            trustFrameworkPolicy: 'TrustFrameworkPolicy',
            policySchemaVersion: 'PolicySchemaVersion',
            tenantId: 'TenantId',
            policyId: 'PolicyId',
            publicPolicyUri: 'PublicPolicyUri',
            basePolicy: 'BasePolicy',
            relyingParty: 'RelyingParty',
            defaultUserJourney: 'DefaultUserJourney',
            referenceId: 'ReferenceId',
            technicalProfile: 'TechnicalProfile',
            id: 'Id',
            displayName: 'DisplayName',
            description: 'Description',
            protocol: 'Protocol',
            name: 'Name',
            handler: 'Handler',
            inputClaimsTransformations: 'InputClaimsTransformations',
            inputClaimsTransformation: 'InputClaimsTransformation',
            inputClaims: 'InputClaims',
            inputClaim: 'InputClaim',
            claimTypeReferenceId: 'ClaimTypeReferenceId',
            defaultValue: 'DefaultValue',
            alwaysUseDefaultValue: 'AlwaysUseDefaultValue',
            partnerClaimType: 'PartnerClaimType',
            required: 'Required',
            displayClaims: 'DisplayClaims',
            displayClaim: 'DisplayClaim',
            displayControlReferenceId: 'DisplayControlReferenceId',
            persistedClaims: 'PersistedClaims',
            persistedClaim: 'PersistedClaim',
            outputClaims: 'OutputClaims',
            outputClaim: 'OutputClaim',
            outputClaimsTransformations: 'OutputClaimsTransformations',
            outputClaimsTransformation: 'OutputClaimsTransformation',
            validationTechnicalProfiles: 'ValidationTechnicalProfiles',
            validationTechnicalProfile: 'ValidationTechnicalProfile',
            continueOnError: 'ContinueOnError',
            continueOnSuccess: 'ContinueOnSuccess',
            preconditions: 'Preconditions',
            precondition: 'Precondition',
            type: 'Type',
            executeActionsIf: 'ExecuteActionsIf',
            value: 'Value',
            action: 'Action',
            subjectNamingInfo: 'SubjectNamingInfo',
            claimType: 'ClaimType',
            includeTechnicalProfile: 'IncludeTechnicalProfile',
            useTechnicalProfileForSessionManagement: 'UseTechnicalProfileForSessionManagement',
            buildingBlocks: 'BuildingBlocks',
            claimsSchema: 'ClaimsSchema',
            userInputType: 'UserInputType',
            restriction: 'Restriction',
            enumeration: 'Enumeration',
            text: 'Text',
            selectByDefault: 'SelectByDefault',
            dataType: 'DataType',
            claimsTransformations: 'ClaimsTransformations',
            claimsTransformation: 'ClaimsTransformation',
            transformationMethod: 'TransformationMethod',
            transformationClaimType: 'TransformationClaimType',
            inputParameters: 'InputParameters',
            inputParameter: 'InputParameter',
            claimsProviders: 'ClaimsProviders',
            claimsProvider: 'ClaimsProvider',
            domain: 'Domain',
            technicalProfiles: 'TechnicalProfiles',
            metadata: 'Metadata',
            item: 'Item',
            key: 'Key',
            cryptographicKeys: 'CryptographicKeys',
            storageReferenceId: 'StorageReferenceId',
            includeInSso: 'IncludeInSso',
            userJourneys: 'UserJourneys',
            userJourney: 'UserJourney',
            orchestrationSteps: 'OrchestrationSteps',
            orchestrationStep: 'OrchestrationStep',
            order: 'Order',
            contentDefinitionReferenceId: 'ContentDefinitionReferenceId',
            cpimIssuerTechnicalProfileReferenceId: 'CpimIssuerTechnicalProfileReferenceId',
            claimsProviderSelections: 'ClaimsProviderSelections',
            claimsProviderSelection: 'ClaimsProviderSelection',
            targetClaimsExchangeId: 'TargetClaimsExchangeId',
            validationClaimsExchangeId: 'ValidationClaimsExchangeId',
            claimsExchanges: 'ClaimsExchanges',
            claimsExchange: 'ClaimsExchange',
            technicalProfileReferenceId: 'TechnicalProfileReferenceId',
            clientDefinition: 'ClientDefinition',
            outputTokenFormat: 'OutputTokenFormat',
            format: 'Format',
            userJourneyBehaviors: 'UserJourneyBehaviors',
            singleSignOn: 'SingleSignOn',
            sessionExpiryType: 'SessionExpiryType',
            sessionExpiryInSeconds: 'SessionExpiryInSeconds',
            scope: 'Scope',
            contentDefinitions: 'ContentDefinitions',
            contentDefinition: 'ContentDefinition',
            loadUri: 'LoadUri',
            recoveryUri: 'RecoveryUri',
            dataUri: 'DataUri',
            localizedResourcesReferences: 'LocalizedResourcesReferences',
            mergeBehavior: 'MergeBehavior',
            localizedResourcesReference: 'LocalizedResourcesReference',
            language: 'Language',
            localizedResourcesReferenceId: 'LocalizedResourcesReferenceId',
            localization: 'Localization',
            supportedLanguages: 'SupportedLanguages',
            supportedLanguage: 'SupportedLanguage',
            localizedResources: 'LocalizedResources',
            defaultLanguage: 'DefaultLanguage',
            localizedStrings: 'LocalizedStrings',
            localizedString: 'LocalizedString',
            elementType: 'ElementType',
            elementId: 'ElementId',
            stringId: 'StringId',
            enabled: 'Enabled',
            clientDefinitions: 'ClientDefinitions',
            clientUIFilterFlags: 'ClientUIFilterFlags',
            deploymentMode: 'DeploymentMode',
            userJourneyRecorderEndpoint: 'UserJourneyRecorderEndpoint',
            journeyInsights: 'JourneyInsights',
            telemetryEngine: 'TelemetryEngine',
            instrumentationKey: 'InstrumentationKey',
            developerMode: 'DeveloperMode',
            clientEnabled: 'ClientEnabled',
            serverEnabled: 'ServerEnabled',
            telemetryVersion: 'TelemetryVersion',
            controlClaimType: 'ControlClaimType',
            displayControls: 'DisplayControls',
            displayControl: 'DisplayControl',
            userInterfaceControlType: 'UserInterfaceControlType',
            actions: 'Actions',
            validationClaimsExchange: 'ValidationClaimsExchange',
            validationClaimsExchangeTechnicalProfile: 'ValidationClaimsExchangeTechnicalProfile',
            predicates: 'Predicates',
            predicate: 'Predicate',
            parameters: 'Parameters',
            parameter: 'Parameter',
            helpText: 'HelpText',
            predicateValidations: 'PredicateValidations',
            predicateValidation: 'PredicateValidation',
            predicateGroups: 'PredicateGroups',
            predicateGroup: 'PredicateGroup',
            userHelpText: 'UserHelpText',
            predicateReferences: 'PredicateReferences',
            matchAtLeast: 'MatchAtLeast',
            predicateReference: 'PredicateReference',
            method: 'Method',
            predicateValidationReference: 'PredicateValidationReference',
            scriptExecution: 'ScriptExecution',
            excludeAsClaim: 'ExcludeAsClaim',
            inputTokenFormat: 'InputTokenFormat',
            endpoints: 'Endpoints',
            endpoint: 'Endpoint',
            userJourneyReferenceId: 'UserJourneyReferenceId',
            authorization: 'Authorization',
            authorizationTechnicalProfiles: 'AuthorizationTechnicalProfiles',
            authorizationTechnicalProfile: 'AuthorizationTechnicalProfile',
            mask: 'Mask',
            regex: 'Regex',
            pattern: 'Pattern',
            regularExpression: 'RegularExpression',
        },
        xmlSchemas: {
            xsd: 'http://www.w3.org/2001/XMLSchema',
            xsi: 'http://www.w3.org/2001/XMLSchema-instance',
            tfp: 'http://schemas.microsoft.com/online/cpim/schemas/2013/06',
        },
        aad: {
            userKeyIdentifiers: {
                email: 'signInNames.emailAddress',
                objectid: 'objectId',
                'foreign objectid': 'userIdentities',
                'short username': 'signInNames.userName',
            },
        },
        restApiSendClaimsIn: {
            body: 'Body',
            form: 'Form',
            header: 'Header',
            url: 'Url',
            queryString: 'QueryString'
        },
        claims: {
            allowedDataTypes: ['boolean', 'string', 'dateTime'],
            allowedUserInputs: {
                string: [
                    'Readonly',
                    'TextBox',
                    'RadioSingleSelect',
                    'Password',
                    'Paragraph',
                    'EmailBox',
                    'DropdownSingleSelect',
                    'CheckboxMultiSelect',
                ],
                boolean: ['Readonly', 'TextBox', 'Paragraph'],
                dateTime: ['Readonly', 'DateTimeDropdown', 'Paragraph'],
            },
            restrictedPasswordClaims: ['newPassword', 'reenterPassword'],
        },
    },
    noDefaultClaimTypes: ['userIdentity', 'userIdentityCollection', 'dateTime', 'stringCollection', 'int'],
    readonlyUserInputTypes: ['Readonly', 'Paragraph'],
    defaultClaimValues: {
        boolean: 'false',
        string: '',
    },
    specialClaims: {
        nca: {
            id: 'nca',
            dataType: 'string',
            userInputType: undefined,
        },
        grant_type: {
            id: 'grant_type',
            dataType: 'string',
            userInputType: undefined,
        },
        scope: {
            id: 'scope',
            dataType: 'string',
            userInputType: undefined,
        },
        client_id: {
            id: 'client_id',
            dataType: 'string',
            userInputType: undefined,
        },
        resource_id: {
            id: 'resource_id',
            dataType: 'string',
            userInputType: undefined,
        },
        identityProvider: {
            id: 'identityProvider',
            dataType: 'string',
            userInputType: undefined,
        },
        upnUserName: {
            id: 'upnUserName',
            dataType: 'string',
            userInputType: undefined,
        },
        userPrincipalName: {
            id: 'userPrincipalName',
            dataType: 'string',
            userInputType: undefined,
        },
        issuerUserId: {
            id: 'issuerUserId',
            dataType: 'string',
            userInputType: undefined,
        },
        emptyUserIdentities: {
            id: 'emptyUserIdentities',
            dataType: 'userIdentityCollection',
            userInputType: undefined,
        },
        userIdentities: {
            id: 'userIdentities',
            dataType: 'userIdentityCollection',
            userInputType: undefined,
        },
        userIdentitiesForRead: {
            id: 'userIdentitiesForRead',
            dataType: 'userIdentityCollection',
            userInputType: undefined,
        },
        'executed-SelfAsserted-Input': {
            id: 'executed-SelfAsserted-Input',
            dataType: 'string',
            userInputType: undefined,
        },
        displayName: {
            id: 'displayName',
            dataType: 'string',
            userInputType: undefined,
        },
        passwordPolicies: {
            id: 'passwordPolicies',
            dataType: 'string',
            userInputType: undefined,
        },
        verificationCode: {
            id: 'verificationCode',
            dataType: 'string',
            userInputType: 'TextBox',
        },
        newPassword: {
            id: 'newPassword',
            dataType: 'string',
            userInputType: 'Password',
        },
        reenterPassword: {
            id: 'reenterPassword',
            dataType: 'string',
            userInputType: 'Password',
        },
        userIdForMFA: {
            id: 'userIdForMFA',
            dataType: 'string',
            userInputType: undefined,
        },
        strCmpBuffer: {
            id: 'strCmpBuffer',
            dataType: 'string',
            userInputType: undefined,
        },
        strCmpBoolBuf: {
            id: 'strCmpBoolBuf',
            dataType: 'boolean',
            userInputType: undefined,
        },
        strCmpPwdBuffer: {
            id: 'strCmpPwdBuffer',
            dataType: 'string',
            userInputType: 'Password',
        },
        webAuthnChallenge: {
            id: 'webAuthnChallenge',
            dataType: 'string',
            userInputType: 'TextBox',
        },
        webAuthnRawId: {
            id: 'webAuthnRawId',
            dataType: 'string',
            userInputType: 'TextBox',
        },
        webAuthnClientDataJson: {
            id: 'webAuthnClientDataJson',
            dataType: 'string',
            userInputType: 'TextBox',
        },
        webAuthnAttestation: {
            id: 'webAuthnAttestation',
            dataType: 'string',
            userInputType: 'TextBox',
        },
        webAuthnSignInNameBuf: {
            id: 'webAuthnSignInNameBuf',
            dataType: 'string',
            userInputType: 'Readonly',
        },
        webAuthnName: {
            id: 'webAuthnName',
            dataType: 'string',
            userInputType: 'Readonly',
        },
        webAuthnDisplayName: {
            id: 'webAuthnDisplayName',
            dataType: 'string',
            userInputType: 'Readonly',
        },
        webAuthnAuthenticatorData: {
            id: 'webAuthnAuthenticatorData',
            dataType: 'string',
            userInputType: 'TextBox',
        },
        webAuthnUserHandle: {
            id: 'webAuthnUserHandle',
            dataType: 'string',
            userInputType: 'TextBox',
        },
        webAuthnSignature: {
            id: 'webAuthnSignature',
            dataType: 'string',
            userInputType: 'TextBox',
        },
        webAuthnPublicKey: {
            id: 'webAuthnPublicKey',
            dataType: 'string',
            userInputType: 'TextBox',
        },
        webAuthnPublicKey1: {
            id: 'webAuthnPublicKey1',
            dataType: 'string',
            userInputType: 'TextBox',
        },
        webAuthnPublicKey2: {
            id: 'webAuthnPublicKey2',
            dataType: 'string',
            userInputType: 'TextBox',
        },
        webAuthnParsedId: {
            id: 'webAuthnParsedId',
            dataType: 'string',
            userInputType: 'TextBox',
        },
        webAuthnRPId: {
            id: 'webAuthnRPId',
            dataType: 'string',
            userInputType: 'TextBox',
        },
        webAuthnHasCredential: {
            id: 'webAuthnHasCredential',
            dataType: 'boolean',
            userInputType: 'TextBox',
        },
        webAuthnAvailable: {
            id: 'webAuthnAvailable',
            dataType: 'boolean',
            userInputType: 'TextBox',
        },
        webAuthnRequirePlatformAuth: {
            id: 'webAuthnRequirePlatformAuth',
            dataType: 'boolean',
            userInputType: 'Readonly',
        },
        booleanCopyBufA: {
            id: 'booleanCopyBufA',
            dataType: 'boolean',
            userInputType: undefined,
        },
        dateTimeSCX: {
            id: 'dateTimeSCX',
            dataType: 'dateTime',
            userInputType: undefined,
        },
        dateTimeComparisonOffset: {
            id: 'dateTimeComparisonOffset',
            dataType: 'int',
            userInputType: undefined,
        },
        booleanNotBuffer: {
            id: 'booleanNotBuffer',
            dataType: 'boolean',
            userInputType: undefined,
        },
        authMethodsUsedForCA: {
            id: 'authMethodsUsedForCA',
            dataType: 'stringCollection',
            userInputType: undefined,
        },
        isFederatedLogin: {
            id: 'isFederatedLogin',
            dataType: 'boolean',
            userInputType: undefined,
        },
        caChallengeBuffer: {
            id: 'caChallengeBuffer',
            dataType: 'stringCollection',
            userInputType: undefined,
        },
        caStatusBuffer: {
            id: 'caStatusBuffer',
            dataType: 'stringCollection',
            userInputType: undefined,
        },
        estsRequestId: {
            id: 'estsRequestId',
            dataType: 'string',
            userInputType: undefined,
        },
        EventTimestamp: {
            id: 'EventTimestamp',
            dataType: 'string',
            userInputType: undefined,
        },
        PolicyId: {
            id: 'PolicyId',
            dataType: 'string',
            userInputType: undefined,
        },
        CorrelationId: {
            id: 'CorrelationId',
            dataType: 'string',
            userInputType: undefined,
        },
        Culture: {
            id: 'Culture',
            dataType: 'string',
            userInputType: undefined,
        },
        EventType: {
            id: 'EventType',
            dataType: 'string',
            userInputType: undefined,
        },
        emailOTP: {
            id: 'emailOTP',
            dataType: 'string',
            userInputType: 'TextBox',
        },
        emailRequestBody: {
            id: 'emailRequestBody',
            dataType: 'string',
            userInputType: undefined,
        },
        instrumentationCorrelationId: {
            id: 'instrumentationCorrelationId',
            dataType: 'string',
            userInputType: undefined,
        },
        instrumentationComponentName: {
            id: 'instrumentationComponentName',
            dataType: 'string',
            userInputType: undefined,
        },
        instrumentationComponentId: {
            id: 'instrumentationComponentId',
            dataType: 'string',
            userInputType: undefined,
        },
        dummyOutputClaim: {
            id: 'dummyOutputClaim',
            dataType: 'string',
            userInputType: undefined,
        },
        aadBearerTokenForRestAuth: {
            id: 'aadBearerTokenForRestAuth',
            dataType: 'string',
            userInputType: undefined
        },
        signInPlaceholderDummy: {
            id: 'signInPlaceholderDummy',
            dataType: 'string',
            userInputType: undefined
        },
        trueBooleanConstant: {
            id: 'trueBooleanConstant',
            dataType: 'boolean',
            userInputType: undefined
        },
        falseBooleanConstant: {
            id: 'falseBooleanConstant',
            dataType: 'boolean',
            userInputType: undefined
        },
        totpSecretKey: {
            id: 'totpSecretKey',
            dataType: 'string',
            userInputType: 'TextBox'
        },
        totpCode: {
            id: 'totpCode',
            dataType: 'string',
            userInputType: 'TextBox'
        },
        QrCodeVerifyInstructions: {
            id: 'QrCodeVerifyInstructions',
            dataType: 'string',
            userInputType: 'Paragraph',
            displayName: 'Enter the verification code from your authenticator app.'
        }
    } as {[index: string]: SpecialClaimInfo},
    reservedClaimNames: [
        'newPassword',
        'reenterPassword',
        'webAuthnAvailable',
        'webAuthnChallenge',
        'webAuthnRawId',
        'webAuthnClientDataJson',
        'webAuthnAttestation',
        'webAuthnRPId',
        'webAuthnUserHandle',
        'webAuthnSignature',
        'webAuthnHasCredential',
        'webAuthnDisplayName',
        'webAuthnName',
        'webAuthnRequirePlatformAuth',
        'EventTimestamp',
        'PolicyId',
        'CorrelationId',
        'Culture',
        'EventType',
    ],
    specialAttributes: {
        userIdentities: 'userIdentities',
        userPrincipalName: 'userPrincipalName',
        objectId: 'objectId',
    },
    claimsProviderNames: {
        mfa: 'MFA',
        usernamePasswordValidation: 'Local Account SignIn',
        policyInstrumentation: 'Policy Instrumentation',
        google: 'Google',
        facebook: 'Facebook',
        webauthnObjectIdCheck: 'WebAuthn OID Check',
        restAADTokens: 'REST AAD Access Tokens',
        totp: 'TOTP'
    },
    federatedLinkTypes: ['google', 'facebook'],
    passwordComplexityOptions: [
        'Lowercase Letters (a to z)',
        'Uppercase Letters (A to Z)',
        'Special character($./!)',
        'length',
        'Number (0-9)',
    ],
    passwordComplexityCharacterSetOptions: [
        'Lowercase Letters (a to z)',
        'Uppercase Letters (A to Z)',
        'Special character($./!)',
        'Number (0-9)',
    ],
    componentTypes: {
        conditional: 'conditional',
        signIn: 'signIn',
        userInput: 'userInput',
        aadRead: 'aadRead',
        aadWrite: 'aadWrite',
        usernamePasswordValidation: 'usernamePasswordValidation',
        tokenIssuer: 'tokenIssuer',
        idp: 'idp',
        rest: 'rest',
        mfa: 'mfa',
        google: 'google',
        webAuthnRegistration: 'webAuthnRegistration',
        webAuthnAuthentication: 'webAuthnAuthentication',
        webAuthnCredentialExists: 'webAuthnCredentialExists',
        webAuthnAvailability: 'webAuthnAvailability',
        conditionalAccessEvaluation: 'conditionalAccessEvaluation',
        conditionalAccessRemediation: 'conditionalAccessRemediation',
        errorPage: 'errorPage',
        authorizeToken: 'authorizeToken',
        userInfoIssuer: 'userInfoIssuer',
        appInsights: 'appInsights',
        sendEmailOTP: 'sendEmailOTP',
        policyInstrumentation: 'policyInstrumentation',
        sessionExists: 'sessionExists',
        oidcIdP: 'oidcIdP',
        samlIdP: 'samlIdP',
        validationError: 'validationError',
        setClaims: 'setClaims'
    },
    editorComponentTypes: {
        conditional: 'conditionals',
        signIn: 'signIn',
        aadRead: 'aadRead',
        aadUpdate: 'aadUpdate',
        aadCreate: 'aadCreate',
        rest: 'restAPI',
        userInput: 'userInputPage',
        mfa: 'mfa',
        tokenIssuer: 'tokenIssuer',
        usernamePasswordValidation: 'usernamePasswordValidation',
        google: 'google',
        webAuthnRegistration: 'webAuthnRegistration',
        webAuthnAuthentication: 'webAuthnAuthentication',
        webAuthnCredentialsExist: 'webAuthnCredentialsExist',
        webAuthnAvailability: 'webAuthnAvailability',
        conditionalAccessEvaluation: 'conditionalAccessEvaluation',
        conditionalAccessRemediation: 'conditionalAccessRemediation',
        errorPage: 'errorPage',
        authorizeToken: 'authorizeToken',
        userInfoIssuer: 'userInfoIssuer',
        appInsights: 'appInsights',
        sendEmailOTP: 'sendEmailOTP',
        sessionExists: 'sessionExists',
        oidcIdP: 'oidcIdP',
        samlIdP: 'samlIdP',
        validationError: 'validationError',
        setClaims: 'setClaims'
    },
    sessionContexts: {
        resolvers: {
            '{Culture:LanguageName}': {
                value: '{Culture:LanguageName}',
                validFor: ['oidc', 'saml'],
                cleanName: 'LanguageName',
            },
            '{Culture:LCID}': {
                value: '{Culture:LCID}',
                validFor: ['oidc', 'saml'],
                cleanName: 'LCID',
            },
            '{Culture:RegionName}': {
                value: '{Culture:RegionName}',
                validFor: ['oidc', 'saml'],
                cleanName: 'RegionName',
            },
            '{Culture:RFC5646}': {
                value: '{Culture:RFC5646}',
                validFor: ['oidc', 'saml'],
                cleanName: 'RFC5646',
            },
            '{Policy:PolicyId}': {
                value: '{Policy:PolicyId}',
                validFor: ['oidc', 'saml'],
                cleanName: 'PolicyId',
            },
            '{Policy:RelyingPartyTenantId}': {
                value: '{Policy:RelyingPartyTenantId}',
                validFor: ['oidc', 'saml'],
                cleanName: 'RelyingPartyTenantId',
            },
            '{Policy:TenantObjectId}': {
                value: '{Policy:TenantObjectId}',
                validFor: ['oidc', 'saml'],
                cleanName: 'TenantObjectId',
            },
            '{Policy:TrustFrameworkTenantId}': {
                value: '{Policy:TrustFrameworkTenantId}',
                validFor: ['oidc', 'saml'],
                cleanName: 'TrustFrameworkTenantId',
            },
            '{Context:BuildNumber}': {
                value: '{Context:BuildNumber}',
                validFor: ['oidc', 'saml'],
                cleanName: 'BuildNumber',
            },
            '{Context:CorrelationId}': {
                value: '{Context:CorrelationId}',
                validFor: ['oidc', 'saml'],
                cleanName: 'CorrelationId',
            },
            '{Context:DateTimeInUtc}': {
                value: '{Context:DateTimeInUtc}',
                validFor: ['oidc', 'saml'],
                cleanName: 'DateTimeInUtc',
            },
            '{Context:DeploymentMode}': {
                value: '{Context:DeploymentMode}',
                validFor: ['oidc', 'saml'],
                cleanName: 'DeploymentMode',
            },
            '{Context:HostName}': {
                value: '{Context:HostName}',
                validFor: ['oidc', 'saml'],
                cleanName: 'HostName',
            },
            '{Context:IPAddress}': {
                value: '{Context:IPAddress}',
                validFor: ['oidc', 'saml'],
                cleanName: 'IPAddress',
            },
            '{Context:KMSI}': {
                value: '{Context:KMSI}',
                validFor: ['oidc', 'saml'],
                cleanName: 'KMSI',
            },
            '{OIDC:AuthenticationContextReferences}': {
                value: '{OIDC:AuthenticationContextReferences}',
                validFor: ['oidc'],
                cleanName: 'AuthContextReferences',
            },
            '{OIDC:ClientId}': {
                value: '{OIDC:ClientId}',
                validFor: ['oidc'],
                cleanName: 'ClientId',
            },
            '{OIDC:DomainHint}': {
                value: '{OIDC:DomainHint}',
                validFor: ['oidc'],
                cleanName: 'DomainHint',
            },
            '{OIDC:LoginHint}': {
                value: '{OIDC:LoginHint}',
                validFor: ['oidc'],
                cleanName: 'LoginHint',
            },
            '{OIDC:MaxAge}': {
                value: '{OIDC:MaxAge}',
                validFor: ['oidc'],
                cleanName: 'MaxAge',
            },
            '{OIDC:Nonce}': {
                value: '{OIDC:Nonce}',
                validFor: ['oidc'],
                cleanName: 'Nonce',
            },
            '{OIDC:Password}': {
                value: '{OIDC:Password}',
                validFor: ['oidc'],
                cleanName: 'Password',
            },
            '{OIDC:Prompt}': {
                value: '{OIDC:Prompt}',
                validFor: ['oidc'],
                cleanName: 'Prompt',
            },
            '{OIDC:RedirectUri}': {
                value: '{OIDC:RedirectUri}',
                validFor: ['oidc'],
                cleanName: 'RedirectUri',
            },
            '{OIDC:Resource}': {
                value: '{OIDC:Resource}',
                validFor: ['oidc'],
                cleanName: 'Resource',
            },
            '{OIDC:Scope}': {
                value: '{OIDC:Scope}',
                validFor: ['oidc'],
                cleanName: 'Scope',
            },
            '{OIDC:Username}': {
                value: '{OIDC:Username}',
                validFor: ['oidc'],
                cleanName: 'Username',
            },
            '{oauth2:access_token}': {
                value: '{oauth2:access_token}',
                validFor: ['oauth2'],
                cleanName: 'access_token',
            },
            '{oauth2:token_type}': {
                value: '{oauth2:token_type}',
                validFor: ['oauth2'],
                cleanName: 'token_type',
            },
            '{oauth2:expires_in}': {
                value: '{oauth2:expires_in}',
                validFor: ['oauth2'],
                cleanName: 'expires_in',
            },
            '{oauth2:refresh_token}': {
                value: '{oauth2:refresh_token}',
                validFor: ['oauth2'],
                cleanName: 'refresh_token',
            },
            '{SAML:AuthnContextClassReferences}': {
                value: '{SAML:AuthnContextClassReferences}',
                validFor: ['saml'],
                cleanName: 'AuthnContextClassRefs',
            },
            '{SAML:NameIdPolicyFormat}': {
                value: '{SAML:NameIdPolicyFormat}',
                validFor: ['saml'],
                cleanName: 'NameIdPolicyFormat',
            },
            '{SAML:Issuer}': {
                value: '{SAML:Issuer}',
                validFor: ['saml'],
                cleanName: 'Issuer',
            },
            '{SAML:AllowCreate}': {
                value: '{SAML:AllowCreate}',
                validFor: ['saml'],
                cleanName: 'AllowCreate',
            },
            '{SAML:ForceAuthn}': {
                value: '{SAML:ForceAuthn}',
                validFor: ['saml'],
                cleanName: 'ForceAuthn',
            },
            '{SAML:ProviderName}': {
                value: '{SAML:ProviderName}',
                validFor: ['saml'],
                cleanName: 'ProviderName',
            },
            '{SAML:RelayState}': {
                value: '{SAML:RelayState}',
                validFor: ['saml'],
                cleanName: 'RelayState',
            },
            '{SAML:Subject}': {
                value: '{SAML:Subject}',
                validFor: ['saml'],
                cleanName: 'Subject',
            },
            '{SAML:Binding}': {
                value: '{SAML:Binding}',
                validFor: ['saml'],
                cleanName: 'Binding',
            },
        },
        customKeyResolvers: {
            'OAUTH-KV': {
                prefix: '{OAUTH-KV:',
                validFor: ['oidc', 'oauth2'],
                cleanName: 'OAUTHKV',
            },
            Claim: {
                prefix: '{Claim:',
                validFor: ['oidc', 'saml'],
                cleanName: 'Claim',
            },
        },
        specials: {
            CurrentDateTime: {
                specialId: 'CurrentDateTime',
                claimId: 'dateTimeSCX',
                dataType: 'dateTime',
                cleanName: 'CurrentDateTime',
            },
        },
    },
    restAPIs: {
        webAuthnMakeCredential: {
            userHandle: 'webAuthnUserHandle',
            RPId: 'webAuthnRPId',
            rawId: 'webAuthnRawId',
            clientDataJson: 'webAuthnClientDataJson',
            attestation: 'webAuthnAttestation',
            challenge: 'webAuthnChallenge',
            parsedId: 'webAuthnParsedId',
            publicKey1: 'webAuthnPublicKey1',
            publicKey2: 'webAuthnPublicKey2',
            success: 'success',
        },
        webAuthnAssertion: {
            RPId: 'webAuthnRPId',
            rawId: 'webAuthnRawId',
            clientDataJson: 'webAuthnClientDataJson',
            authenticatorData: 'webAuthnAuthenticatorData',
            challenge: 'webAuthnChallenge',
            signature: 'webAuthnSignature',
            publicKey1: 'webAuthnPublicKey1',
            publicKey2: 'webAuthnPublicKey2',
            success: 'isSuccess',
        },
        webAuthnGetCert: {
            authId: 'authId',
            certPart1: 'certPart1',
            certPart2: 'certPart2',
            success: 'isSuccess',
        },
        webAuthnGetAuth: {
            authId: 'authId',
            objectId: 'objectId',
            success: 'isSuccess',
        },
        webAuthnSetCert: {
            authId: 'authId',
            certPart1: 'certPart1',
            certPart2: 'certPart2',
            success: 'isSuccess',
        },
        webAuthnSetAuth: {
            authId: 'authId',
            objectId: 'objectId',
            success: 'isSuccess',
        },
        webAuthnGetChallenge: {
            challenge: 'challenge',
        },
    },
    validRESTClaimDataTypes: [
        'boolean',
        'string',
        'stringCollection',
        'dateTime',
        'date',
        'int',
        'long',
        'objectIdentity',
        'objectIdentityCollection',
    ],
    canTakeArbitraryOutputClaims: ['selfAsserted', 'claimsTransformation', 'OAuth2'],
    oidcScopes: {
        openid: 'openid',
        profile: 'profile',
        email: 'email',
        address: 'address',
        phone: 'phone'
    },
    oidcClaims: {
        name: {
            id: 'name',
            scope: 'profile',
        },
        family_name: {
            id: '',
            scope: 'profile',
        },
        given_name: {
            id: 'given_name',
            scope: 'profile',
        },
        middle_name: {
            id: 'middle_name',
            scope: 'profile',
        },
        nickname: {
            id: 'nickname',
            scope: 'profile',
        },
        preferred_username: {
            id: 'preferred_username',
            scope: 'profile',
        },
        profile: {
            id: 'profile',
            scope: 'profile',
        },
        picture: {
            id: 'picture',
            scope: 'profile',
        },
        website: {
            id: 'website',
            scope: 'profile',
        },
        gender: {
            id: 'gender',
            scope: 'profile',
        },
        birthdate: {
            id: 'birthdate',
            scope: 'profile',
        },
        zoneinfo: {
            id: 'zoneinfo',
            scope: 'profile',
        },
        locale: {
            id: 'locale',
            scope: 'profile',
        },
        updated_at: {
            id: 'updated_at',
            scope: 'profile',
        },
        email: {
            id: 'email',
            scope: 'email'
        },
        email_verified: {
            id: 'email_verified',
            scope: 'email'
        },
        address: {
            id: 'address',
            scope: 'address'
        },
        phone_number: {
            id: 'phone_number',
            scope: 'phone'
        },
        phone_number_verified: {
            id: 'phone_number_verified',
            scope: 'phone'
        }
    },
    restAuthTypes: {
        none: {
            id: 'none',
            policyAuthType: 'None',
            allowInsecureAuthInProduction: true
        },
        aadBearer: {
            id: 'aadBearer',
            policyAuthType: 'Bearer',
            allowInsecureAuthInProduction: false
        },
        clientCert: {
            id: 'clientCert',
            policyAuthType: 'ClientCertificate',
            allowInsecureAuthInProduction: false
        }
    },
    sessionActions: {
        always: 'always',
        flagSession: 'flagSession',
        globalSSO: 'globalSSO'
    },
    ssoSessionScopes: {
        Tenant: 'Tenant',
        Application: 'Application',
        Policy: 'Policy',
        Suppressed: 'Suppressed'
    },
    ssoSessionExpiryTypes: {
        Rolling: 'Rolling',
        Absolute: 'Absolute'
    },
};
